<script setup>
import { onMounted, computed, ref, watch } from "vue";
import store from "@/store";
import SelectTeam from "./SelectTeam.vue";
import Overlay from "../Overlay.vue";
import Modal from "../Poker/Modal.vue";

const loading = ref(false);
// const day = ref(null);
const day = computed(() => {
  return store.state.poker.day;
});

const user = computed(() => {
  return store.state.auth.user;
});

onMounted(async () => {
  fetchDay();
});

const fetchDay = async () => {
  await store.dispatch("poker/getDay");
};

const createDay = async () => {
  await store.dispatch("poker/createDay");
};

const resetDay = async () => {
  await store.dispatch("poker/resetDay");
};

const bonusMultiplier = (count) => {
  const bonuses = {
    0: 0,
    1: 50,
    2: 100,
    3: 150,
    4: 210,
    5: 240,
    6: 260,
    7: 270,
    8: 280,
    9: 290,
    10: 300,
    11: 310,
    12: 320,
    13: 330,
    14: 340,
    15: 350,
  };

  if (count > 15) {
    return bonuses[15] * count;
  } else if (count === 0) {
    return 0;
  } else {
    return bonuses[count] * count;
  }
};
</script>

<template>
  <template v-if="!day">
    <div class="p-8 rounded-xl bg-ch1cream flex flex-col items-center justify-center m-4">
      <img :src="require('@/assets/chapter-1/nigel-ww-min.png')" class="w-24" />
      <div class="font-ch1script text-5xl text-ch1blue mb-8">Loading</div>
    </div>
  </template>
  <template v-else>
    <SelectTeam />
  </template>
</template>

<style lang="postcss"></style>
